<template>
  <div id="grn-create" class="group-setup">
    <!-- GRN Creation -->
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>

    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>

    <v-form v-if="!loading">
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-card class="pa-5" flat>
            <HeaderDividerBlock headerText="Create GRN"> </HeaderDividerBlock>
            <v-row>
              <!-- PO Number -->
              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Purchase Order Number</p>
                </v-col>
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.po_number"
                  required
                  clearable
                  placeholder="Select PO Number"
                  :items="purchaseOrders"
                  item-text="po_number"
                  item-value="po_number"
                  no-data-text="Search PO number"
                  @update:search-input="handleSearchInput"
                ></v-autocomplete>
              </v-col>

              <!-- GRN Date -->
              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">GRN Date</p>
                </v-col>
                <DatePicker
                  v-model="form.grn_date"
                  placeholder="GRN Date"
                  :max="new Date().toISOString().substr(0, 10)"
                ></DatePicker>
              </v-col>

              <!-- Remarks -->
              <v-col cols="12" sm="12">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Remarks</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.remarks"
                  placeholder="Remarks"
                  required
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- GRN Items -->
            <v-col cols="12" md="12" sm="12">
              <GrnItems
                :products="products"
                @total="handleTotal"
                @items="handleItems"
              >
              </GrnItems>
            </v-col>

            <!-- Summary -->
            <!-- <v-col cols="12" md="6" sm="12">
        <v-col>
          <v-col class="ma-0 pa-0">
            <p class="text-h5 font-weight-bold">Summary</p>
          </v-col>
          <v-col class="px-7 pa-10 total-section">
            <v-row class="justify-space-between">
              <p class="text-subtitle-1 font-weight-bold">Sub Total</p>
              <p>{{ calculateSubtotal() }}</p>
            </v-row>
            <v-row class="justify-space-between">
              <p class="text-subtitle-1 font-weight-bold">Discount Amount</p>
              <p>{{ calculateTotalDiscount() }}</p>
            </v-row>
            <v-row class="justify-space-between">
              <p class="text-subtitle-1 font-weight-bold">Tax Amount</p>
              <p>{{ calculateTotalTax() }}</p>
            </v-row>
            <v-row class="justify-space-between">
              <p class="text-subtitle-1 font-weight-bold">Grand Total</p>
              <p>{{ calculateGrandTotal() }}</p>
            </v-row>
          </v-col>
        </v-col>
      </v-col> -->

            <!-- Submit Button -->
            <v-card-actions class="mt-10">
              <v-row>
                <v-col cols="12" md="10" xs="6"></v-col>
                <v-col cols="12" md="2" xs="6">
                  <v-btn
                    v-if="hasPermission('grn.create')"
                    large
                    color="#00B3FF"
                    dark
                    depressed
                    block
                    @click="submit"
                  >
                    Create GRN
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="clossSnackbar"
    />
  </div>
</template>

<script>
import DatePicker from "@/components/shared/DatePicker";
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import { checkError } from "@/config/errors.js";
import { GrnService } from "@/services/grn-service.js";
import GrnItems from "@/components/grn/GrnItems";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "CreateGrnForm",
  components: {
    Alert,
    Snackbars,
    DatePicker,
    HeaderDividerBlock,
    GrnItems,
  },
  data: () => ({
    searchQuery: "",
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",
    search: "",
    form: {
      po_number: "",
      grn_date: new Date().toISOString().substr(0, 10),
      sub_total: 0.0,
      discount_amount: 0.0,
      tax_amount: 0.0,
      grand_total: 0.0,
      remarks: "",
      items: [],
      total_amount: 0.0,
    },
    branches: [],
    //suppliers: [],
    products: [],

    purchaseOrders: [],
    loadingBranches: false,
    loadingSuppliers: false,
    loadingProducts: false,
    loadingBatches: false,
    loadingPurchaseOrders: false,
    debounceTimer: null,
    role: localStorage.getItem("role") || null,
  }),
  watch: {
    "form.po_number": async function(newPoNumber) {
      // Fetch products if PO Number is selected
      if (newPoNumber) {
        try {
          this.loadingProducts = true;
          const products = await GrnService.getItemsByPoNumber(newPoNumber);

          this.products = products.filter(
            (p) => p.quantity > p.quantity_already_received
          );
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingProducts = false;
        }
      }
    },
  },
  created() {
    this.fetchBranchesSuppliersProducts();
    this.fetchBatches();
  },
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
    dateValidation() {
      return (value) => {
        if (new Date(value) > new Date()) {
          return "Date cannot be in the future";
        }
        return true;
      };
    },
  },
  methods: {
    handleSearchInput(query) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.fetchPurchaseOrders(query);
      }, 500);
    },

    async fetchPurchaseOrders(query) {
      if (query.length < 2) return;

      this.loadingPurchaseOrders = true;

      try {
        const response = await GrnService.getPurchaseOrdersBySearch(query);
        this.purchaseOrders = (response.data || []).filter(
          (po) => po.status === "pending"
        );
      } catch (error) {
        console.error("Error fetching purchase orders:", error);
        this.purchaseOrders = [];
      } finally {
        this.loadingPurchaseOrders = false;
      }
    },

    async submit() {
      this.loading = true;
      this.errors = null;
      try {
        const response = await GrnService.createGrn(this.form);
        console.log(response);
        this.succesMsg = "GRN created successfully!";
        this.snackbar = true;
        this.form = {
          po_id: "",
          grn_date: new Date().toISOString().substr(0, 10),
          sub_total: 0.0,
          discount_amount: 0.0,
          tax_amount: 0.0,
          grand_total: 0.0,
          remarks: "",
          items: [],
        };
      } catch (err) {
        this.loading = false;
        let data =
          err.response?.data ||
          "An error occurred while creating the GRN. Please check the form and try again.";
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
        window.scrollTo(0, 0);
      }
      this.loading = false;
    },

    async fetchBranchesSuppliersProducts() {
      try {
        this.loadingBranches = true;
        this.loadingSuppliers = true;
        const branches = await GrnService.getBranches();
        const suppliers = await GrnService.getSuppliers();
        this.branches = branches.data;
        this.suppliers = suppliers.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingBranches = false;
        this.loadingSuppliers = false;
      }
    },
    calculateSubtotal() {
      let subtotal = 0;
      this.form.items.forEach((item) => {
        subtotal += item.quantity_received * item.unit_price;
      });
      this.form.sub_total = subtotal;
      return parseFloat(subtotal);
    },
    calculateTotalDiscount() {
      let discount = 0;
      this.form.items.forEach((item) => {
        discount += item.discount_amount;
      });
      this.form.discount_amount = discount;
      return parseFloat(this.form.discount_amount);
    },
    calculateTotalTax() {
      let tax = 0;
      this.form.items.forEach((item) => {
        tax += item.tax_amount;
      });
      this.form.tax_amount = tax;
      return parseFloat(tax);
    },
    calculateGrandTotal() {
      let grandTotal =
        parseFloat(this.calculateSubtotal()) -
        parseFloat(this.calculateTotalDiscount()) +
        parseFloat(this.calculateTotalTax());
      this.form.grand_total = grandTotal;
      return grandTotal;
    },

    handleItems(items) {
      this.form.items = items;
    },
    handleTotal(total) {
      this.form.total_amount = total;
    },
  },
};
</script>
